import React from "react";
import { Popover } from "antd";
import { AiOutlineClose } from "react-icons/ai";
import TextInputModal from "../../../../../components/common/TextInputModal";
import { ClearFilterButton } from "../../../../../components/common/Buttons";
import { IconExpand } from "../../../../../components/Layout/Icons";
import "./SkuPopover.css";

/**
 * SkuPopover component
 * @param {boolean} open - Indicates whether the popover is open
 * @param {function} setOpen - Function to set the `open` state
 * @param {array} products - Array of products
 * @param {string} searchVal - The current search value
 * @param {function} setSearchVal - Function to set the `searchVal` state
 * @param {array} selectedSkusValue - Array of selected SKUs
 * @param {function} removeSku - Function to remove a SKU
 */

const SkuPopover = ({
  open,
  setOpen,
  products,
  searchVal,
  setSearchVal,
  selectedSkusValue,
  removeSku,
}) => {
  const SkuItem = ({ sku, id }) => (
    <div className="d-flex align-items-center justify-content-between skuItem">
      <div>
        <span className="text-small text-black">{sku}</span>
      </div>
      <div
        onClick={() => removeSku(id)}
        className="d-flex justify-content-center cursor-pointer"
      >
        <AiOutlineClose />
      </div>
    </div>
  );

  return (
    <Popover
      placement="left"
      title={
        <div className="d-flex align-items-center justify-content-between py-2">
          <div className="font-semi-bold text-base text-black">SKU</div>
          <div>
            {products?.length} SKU in the list {selectedSkusValue?.length}
          </div>
          <AiOutlineClose
            className="cursor-pointer text-black"
            onClick={() => setOpen(false)}
          />
        </div>
      }
      content={
        open ? (
          <div className="popoverContent">
            <div className="d-flex align-items-center mb-2">
              <div className="flex-1" style={{ marginRight: 20 }}>
                <TextInputModal
                  style={{
                    width: "100%",
                  }}
                  placeholder="SKU"
                  value={searchVal}
                  onChange={(e) => {
                    const val = e.target.value;
                    setSearchVal(val);
                  }}
                />
              </div>
              <ClearFilterButton onClick={() => setSearchVal("")} />
            </div>
            <div className="popoverContentBorder">
              <div className="d-flex flex-row flex-wrap sku-container">
                {selectedSkusValue
                  .filter((item) => item.sku.includes(searchVal))
                  .map((item, index) => (
                    <SkuItem key={index} sku={item.sku} id={item.id} />
                  ))}
              </div>
            </div>
          </div>
        ) : (
          ""
        )
      }
      trigger="click"
      open={open || false}
    >
      <div className={`popoverTrigger ${open ? "blur" : ""}`}>
        <div className="d-flex flex-row flex-wrap">
          {selectedSkusValue.slice(0, 9).map((item, index) => (
            <SkuItem key={index} sku={item.sku} id={item.id} />
          ))}
        </div>
        {selectedSkusValue?.length > 9 && (
          <div>
            <div
              className="d-flex align-items-center justify-content-center cursor-pointer text-primary pt-3 pb-2"
              onClick={() => setOpen(true)}
            >
              <IconExpand className="text-xl text-primary mr-2" />
              Click here to expand view
            </div>
          </div>
        )}
      </div>
    </Popover>
  );
};

export default SkuPopover;
